module.exports = "/_next/static/images/coming-soon-uv-983b7e2aad4364ec5d209a7e11bc157f.png";